import {
  AssessmentGroupListFragmentFragment,
  ComplianceProgramStep,
  OrganizationTalentIndicatorFragment,
} from "types/graphql-schema";
import { FormError } from "types/topicflow";

import EngagementSurveyStep from "../steps/engagement-survey-step";
import PeerAssessmentStep from "../steps/peer-assessment-step";
import SelfManagerAssessmentStep from "../steps/self-manager-assessment-step";
import UpwardAssessmentStep from "../steps/upward-assessment-step";
import { ProgramForm, ProgramFormStep } from "../types";

const ProgramFormQuestions = ({
  proposedComplianceProgram,
  canUpdate,
  talentIndicatorData,
  availableAssessmentGroups,
  onAssessmentGroupCreated,
  onAssessmentGroupArchived,
  onAddOrUpdateStep,
  errors,
}: {
  canUpdate: boolean;
  proposedComplianceProgram: ProgramForm;
  talentIndicatorData?: OrganizationTalentIndicatorFragment[];
  availableAssessmentGroups: AssessmentGroupListFragmentFragment[];
  onAssessmentGroupCreated: (
    newAssessmentGroup: AssessmentGroupListFragmentFragment,
  ) => void;
  onAssessmentGroupArchived: (assessmentGroupId: number) => void;
  onAddOrUpdateStep: (step: ProgramFormStep) => void;
  errors: FormError[];
}) => {
  const activeSteps = proposedComplianceProgram.steps.map(
    ({ stepType }) => stepType,
  );
  const showQuestionSetError = errors.some(
    (error) => error.field === "questionSetIds",
  );
  return (
    <div id="field-questionSetIds" className="flex flex-col gap-8 scroll-mt-24">
      {activeSteps.includes(ComplianceProgramStep.SelfReview) &&
        activeSteps.includes(ComplianceProgramStep.DownwardReview) && (
          <SelfManagerAssessmentStep
            proposedComplianceProgram={proposedComplianceProgram}
            canUpdate={canUpdate}
            talentIndicatorData={talentIndicatorData}
            availableAssessmentGroups={availableAssessmentGroups}
            onAssessmentGroupCreated={onAssessmentGroupCreated}
            onAssessmentGroupArchived={onAssessmentGroupArchived}
            onAddOrUpdateStep={onAddOrUpdateStep}
            showQuestionSetError={showQuestionSetError}
          />
        )}

      {activeSteps.includes(ComplianceProgramStep.UpwardReview) && (
        <UpwardAssessmentStep
          proposedComplianceProgram={proposedComplianceProgram}
          canUpdate={canUpdate}
          talentIndicatorData={talentIndicatorData}
          onAddOrUpdateStep={onAddOrUpdateStep}
          availableAssessmentGroups={availableAssessmentGroups}
          onAssessmentGroupCreated={onAssessmentGroupCreated}
          onAssessmentGroupArchived={onAssessmentGroupArchived}
          showQuestionSetError={showQuestionSetError}
        />
      )}

      {activeSteps.includes(ComplianceProgramStep.PeerReview) && (
        <PeerAssessmentStep
          proposedComplianceProgram={proposedComplianceProgram}
          canUpdate={canUpdate}
          onAddOrUpdateStep={onAddOrUpdateStep}
          availableAssessmentGroups={availableAssessmentGroups}
          onAssessmentGroupCreated={onAssessmentGroupCreated}
          onAssessmentGroupArchived={onAssessmentGroupArchived}
          showQuestionSetError={showQuestionSetError}
        />
      )}

      {activeSteps.includes(ComplianceProgramStep.EngagementSurvey) && (
        <EngagementSurveyStep
          proposedComplianceProgram={proposedComplianceProgram}
          canUpdate={canUpdate}
          onAddOrUpdateStep={onAddOrUpdateStep}
          availableAssessmentGroups={availableAssessmentGroups}
          onAssessmentGroupCreated={onAssessmentGroupCreated}
          onAssessmentGroupArchived={onAssessmentGroupArchived}
          showQuestionSetError={showQuestionSetError}
        />
      )}
    </div>
  );
};

export default ProgramFormQuestions;
